import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a69afc3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex px-4" }
const _hoisted_2 = { class: "flex justify-center items-center gap-4" }
const _hoisted_3 = { class: "font-bold text-[#9BB441] text-[28px]" }
const _hoisted_4 = { class: "font-light text-[12px]" }
const _hoisted_5 = { class: "border-card-top mt-2 flex justify-start gap-5 p-4" }
const _hoisted_6 = { class: "flex gap-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-[12px]" }, "Serie A", -1))
const _hoisted_8 = { class: "text-[#9BB441] text-[12px] font-[900]" }
const _hoisted_9 = { class: "flex gap-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-[12px]" }, "Serie B", -1))
const _hoisted_11 = { class: "text-[#9BB441] text-[12px] font-[900]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ComponentCard = _resolveComponent("ComponentCard")!

  return (_openBlock(), _createBlock(_component_ComponentCard, {
    title: _ctx.title,
    class: "max-h-40 justify-center"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.metric), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.description), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.seriea), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.serieb), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}